<template>
  <div>
    <div class="comp-container">
      <p style="font-size: 26px;margin-top:20px;margin-left: 25px">盲人求助消息</p>
      <Tabs value="name1" style="margin-top:20px;margin-left: 25px">
        <TabPane label="全部消息" name="name1">
          <table class="headTable">
            <tr>
              <td>时间</td>
              <td>
                <DatePicker
                  type="datetimerange"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="开始时间-结束时间"
                  clearable
                  v-model="checkedTime"
                  @on-change="dateTimeChange"
                  @on-clear="dateTimeClear"
                />
              </td>
              <td>用户来源</td>
              <td>
                <Select v-model="source" style="width:10rem;" @on-change="sourceChange">
                  <Option value="0">全选</Option>
                  <Option value="2">小程序</Option>
                  <Option value="1">App</Option>
                </Select>
              </td>
              <td>求助方式</td>
              <td>
                <Select v-model="askWay" style="width:15rem;" @on-change="askWayChange">
                  <Option
                    v-for="item in askWayArr"
                    :key="item.key"
                    :value="item.key"
                  >{{item.content}}</Option>
                </Select>
              </td>
              <td>
                <Button type="default" @click.native="search">筛选</Button>
              </td>
            </tr>
          </table>
          <table style="width:98%">
            <tr>
              <td>
                <table class="headTable" style="width: 100%;margin-top: 10px">
                  <tr>
                    <td>求助内容</td>
                    <td>
                      <Input
                        type="text"
                        placeholder="支持模糊搜索"
                        v-model="helpContent"
                        clearable
                        @on-change="helpContentChange"
                        @on-enter="search"
                      />
                    </td>
                    <td>盲人昵称</td>
                    <td>
                      <Input
                        type="text"
                        placeholder="支持模糊搜索"
                        v-model="blindNick"
                        clearable
                        @on-change="blindNickChange"
                        @on-enter="search"
                      />
                    </td>
                    <td>
                      <Button type="default" @click.native="search">搜索</Button>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <div style="margin-top:20px;">
            <Table
              stripe
              :columns="columns1"
              :data="helpMessage"
              :loading="tableLoading"
              class="mainTable"
              ref="selection"
              @on-selection-change="handleSelectRow()"
            ></Table>
            <Page
              :total="pageTotal"
              :page-size="pageSize"
              :current="currPage"
              style="text-align:center;margin:50px;"
              @on-change="pageChange"
              show-elevator
            />
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
  import Button from "iview/src/components/button/button";
  import { format } from "../../utils/format.js";
  import Checkbox from "iview/src/components/checkbox/checkbox";
  import Card from "iview/src/components/card/card";
  import { adminRouter } from "../../router/admin";

  export default {
    components: {
      Card,
      Checkbox,
      Button
    },
    name: "helpMessage",
    data() {
      return {
        helpMessage: [], //后台传入的信息
        vitalInfo: "", //搜索框求助内容
        vitalNick: "", //搜索框盲人昵称
        askWay: "", //求助方式
        source: "", //用户来源
        checkWay: [],
        askWayArr: [
          {
            key: 0,
            content: "全选"
          },
          {
            key: 1,
            content: "图片+文字"
          },
          {
            key: 2,
            content: "图片+语音"
          },
          {
            key: 3,
            content: "短视频"
          },
          {
            key: 4,
            content: "实时视频"
          }
        ],
        checkedTime: "" /*选择的时间*/,
        checkedHelpMessage: [], //已经选中的项目
        tableLoading: true, //加载状态
        helpContent: "", //求助内容
        blindNick: "", //盲人昵称
        filterInfo: {
          code: 0,
          channel: 0, //求助途径
          content: {}, //求助内容
          currPage: 1 //当前页
        },
        pageSize: 20, //每页显示条数
        pageTotal: 0,
        currPage: 1,
        columns1: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "Id",
            key: "id"
          },
          {
            title: "求助时间",
            key: "createTime",
            width: 150,
            sortable: true,
            render: (h, params) => {
              return h("div", format(params.row.createTime, "yyyy-MM-dd hh:mm"));
            }
          },
          {
            title: "求助方式",
            key: "status",
            width: 120,
            render: function(h, params) {
              let content = "";
              switch (params.row.status) {
                case 1:
                  content = "文字+图片";
                  break;
                case 2:
                  content = "图片+语音";
                  break;
                case 3:
                  content = "短视频";
                  break;
                case 4:
                  content = "实时视频";
                  break;
                default:
                  content = "未知";
                  break;
              }
              return h("div", content);
            }
          },
          {
            title: "盲人昵称",
            key: "nickname"
          },
          {
            title: "问题缩略",
            key: "helpText",
            width: 200,
            render: (h, params) => {
              return h(
                "div",
                params.row.helpText ? (params.row.helpText.length > 20
                  ? params.row.helpText.substr(0, 20) + "..."
                  : params.row.helpText)
                  : ""

              );
            }
          },
          {
            title: "问题来源",
            key: "device",
            render: (h, params) => {
              return h(
                "div",
                params.row.channel === 1 ? "启明瞳app" : "启明瞳小程序"
              );
            }
          },
          {
            title: "详情",
            render: (h, params) => {
              return h("Button", {
                props: {
                  type: "primary",
                  icon: "ios-arrow-right"
                },
                style: {
                  border: "none",
                  fontSize: "20px"
                },
                on: {
                  click: () => {
                    let id = parseInt(this.helpMessage[params.index].id);
                    let helpInfo = {};
                    let offerHelpInfos = [];
                    this.$http.post("/zm/help/getQuestionAndAnswer", {"id": id}).then(res => {
                        helpInfo = res.data.content.helpInfo;
                        offerHelpInfos = res.data.content.offerHelpInfos;
                        if(!helpInfo.openid){
                          this.$Message.error("获取信息失败");
                          return;
                        }
                        let active = "helpMessageDetail";     //下个版本更新url
                        this.$http.post("/zm/backManage/queryAllQuestionsByOpenid", {"content": {}, "openid": helpInfo.openid}).then(res => {
                            if (this.currentTag !== active) {
                              let tags = null;
                              for (let ele of adminRouter) {
                                if (ele.name === active) {
                                  tags = {
                                    title: ele.title,
                                    name: ele.name,
                                    path: ele.path
                                  };
                                  break;
                                } else {
                                  if (ele.children.length) {
                                    for (let val of ele.children) {
                                      if (val.name === active) {
                                        tags = {
                                          title: val.title,
                                          name: val.name,
                                          path: val.path
                                        };
                                        break;
                                      }
                                    }
                                  }
                                }
                              }
                              localStorage.setItem("currentTag", active);
                              this.$store.commit("updateCurrentTag", active);
                              this.$store.commit("updateOpenedTags", [tags]);
                              this.$store.commit("updateCurrentPath", active);
                              Object.assign(helpInfo, res);
                              this.$router.push({
                                name: "helpMessageDetail",
                                params: {
                                  "helpInfo": helpInfo,
                                  "offerHelpInfos": offerHelpInfos
                                }
                              });
                            }
                          },
                          err => {
                            this.$Message.error("请求失败：" + err.message);
                          });

                      },
                      err => {
                        this.$Message.error("请求失败：" + err.message);
                      });
                  }
                }
              });
            }
          }
        ]
      };
    },
    created() {
      this.$data.tableLoading = true;
      this.$http.post("/zm/backManage/queryHelpInfoByPage", this.filterInfo).then(
        res => {
          this.helpMessage = res.data.content;
          this.pageTotal = res.data.pageTotal;
          this.$data.tableLoading = false;
        },
        err => {
          this.$Message.error("请求失败：" + err.message);
          this.$data.tableLoading = false;
        }
      );
    },
    mounted() {},
    methods: {
      /**
       * 选择时间
       */
      dateTimeChange() {
        if (this.checkedTime[0] !== "") {
          this.filterInfo.content.startTime = Math.floor(
            this.checkedTime[0].getTime() / 1000
          );
          this.filterInfo.content.endTime = Math.floor(
            this.checkedTime[1].getTime() / 1000
          );
        } else {
          delete this.filterInfo.content["startTime"];
          delete this.filterInfo.content["endTime"];
        }
      },
      /**
       * 清空时间
       */
      dateTimeClear() {
        delete this.filterInfo.content["startTime"];
        delete this.filterInfo.content["endTime"];
      },
      /**
       * 选择求助来源
       */
      sourceChange() {
        if (this.source === "0") {
          delete this.filterInfo.content["channel"];
        } else {
          this.filterInfo.content.channel = this.source;
        }
      },
      /**
       * 求助方式
       */
      askWayChange() {
        if (this.askWay === 0) {
          delete this.filterInfo.content["askWay"];
        } else {
          this.filterInfo.content.askWay = this.askWay;
        }
      },
      /**
       * 筛选、搜索
       */
      search() {
        this.tableLoading = true;
        this.filterInfo.currPage = 1;
        this.currPage = 1;
        console.log(JSON.stringify(this.filterInfo));
        this.$http
          .post("/zm/backManage/queryHelpInfoByPage", this.filterInfo)
          .then(
            res => {
              this.helpMessage = res.data.content;
              this.pageTotal = res.data.pageTotal;
              this.$data.tableLoading = false;
            },
            err => {
              this.$Message.error("请求失败：" + err.message);
              this.$data.tableLoading = false;
            }
          );
      },
      /**
       * 输入求助内容
       */
      helpContentChange(e) {
        if (this.helpContent === "") {
          delete this.filterInfo.content["helpText"];
        } else {
          this.filterInfo.content.helpText = this.helpContent;
        }
      },
      /**
       * 输入盲人昵称
       */
      blindNickChange() {
        if (this.blindNick === "") {
          delete this.filterInfo.content["nickname"];
        } else {
          this.filterInfo.content.nickname = this.blindNick;
        }
      },
      handleSelectRow() {
        //获取已经选中的项目
        this.checkedHelpMessage = this.$refs.selection.getSelection();
      },
      //翻页
      pageChange(page) {
        this.tableLoading = true;
        this.filterInfo.currPage = page;
        this.currPage = page;
        this.$http
          .post("/zm/backManage/queryHelpInfoByPage", this.filterInfo)
          .then(
            res => {
              this.helpMessage = res.data.content;
              this.pageTotal = res.data.pageTotal;
              this.tableLoading = false;
            },
            err => {
              this.$Message.error("请求失败：" + err.message);
              this.tableLoading = false;
            }
          );
      }
    },

    filters: {}
  };
</script>

<style>
  .comp-container {
    min-width: 800px;
  }
  .headTable {
    font-size: 16px;
    border: solid 2px #cccccc;
    border-radius: 10px;
    padding: 5px 15px;
    width: 98%;
    height: 50px;
    text-align: center;
  }

  .mainTable {
    /*width: 98%;*/
  }

  .mainTable tr:hover {
    background-color: #5cadff;
  }
</style>





// WEBPACK FOOTER //
// helpMessage.vue?6cddf443